import db from '../db.js';
import { parse } from '../misc.js';

// Requires observer.js
export default function (...args)
{
	return {
		async actions(ev, publisher, key)
		{
			// key deve ser string não vazia ou número válido (IDBKeyRange não aceita null, undefined, array ou object)
			const valid = (typeof key === 'string' && key !== '') || (typeof key === 'number' && !isNaN(key) && key >= 0);
			if (!valid)
				return;
			let available = await db.list(this._store, IDBKeyRange.bound([key, ''], [key, '\uffff']), this._index);
			let selected = parse(this.form.getFieldBySelector(this.selector).getValue()).map(entry => String(entry));
			available = available.filter(entry => !selected.includes(String(this._values.map(key => entry[key]))));
			let options = await Promise.all((available ?? []).map(entry => this.makeOption(entry)));
			document.querySelector(`${this?.form.selector} ${this._target}`).innerHTML = options.join('\n');
		}
	};
}

